import LoadScript from "../utils/LoadScript";

export default class PageArchiveRealisation {

	static init() {

		let form = document.querySelector('.realisation-search-form');
		if( !form ){
			return;
		}

		const input = form.querySelector("input[name='location']");
		const coordinate = form.querySelector("input[name='coordinate']");

		input.addEventListener("focus", () => {
			LoadScript.load("https://maps.googleapis.com/maps/api/js?v=3.57&key=" + mcArgs.gmapApiKey + "&callback=Function.prototype&libraries=marker,places", () => {
				const options = {
					componentRestrictions: {country: 'fr'}
				};
				const searchBox = new google.maps.places.Autocomplete(input, options);
				searchBox.addListener("place_changed", (e) => {
					const places = searchBox.getPlace();
					if (places.length === 0) {
						return;
					}
					coordinate.value = places.geometry.location.lat() + ',' + places.geometry.location.lng();
				});
			});
		});

		input.addEventListener("blur", () => {
			if( input.value === "" ){
				coordinate.value = "";
			}
		});

		let filterMainSolution = form.querySelectorAll('input[name="main-solution"]');
		let filterSecondarySolution = form.querySelector('select');
		let filterSecondarySolutionOption = form.querySelectorAll('select option');
		filterMainSolution.forEach( (filter) => {
			filter.addEventListener("change", () => {
				const value = filter.value;
				filterSecondarySolutionOption.forEach( (f) => {
					f.classList.add('d-none');
					f.removeAttribute('selected');
					if( f.dataset.mainSolution === value || f.value === "" ){
						f.classList.remove('d-none');
					}
				});
				filterSecondarySolution.value = "";
				filterSecondarySolution.querySelector('option:not(.d-none)').setAttribute('selected','selected');
			});
		});

	}
}